import api from 'api/axiosInstance';
import type { RedirectionParams } from 'types/global.types';
import type { CardType } from 'types/transactions.types';

export type GetSensitiveDataParams = RedirectionParams & {
  type: CardType;
};

export const getCardSensitiveData = (
  id?: string,
  params?: GetSensitiveDataParams,
): Promise<{ redirectUri: string }> =>
  api.post(
    `/v2/accountable-banking/cards/${id}/sensitive-information/start-flow`,
    params,
  );
